/* eslint no-console:0 */
// This is the entrypoint for the `clubroom` child theme. The files
// imported here will be included on every page of the clubroom website.
//
// To reference this file, add <%= javascript_pack_tag 'clubroom' %> to the appropriate
// layout file, like frontend/clubroom/layouts/application.haml
import 'shared/assets/css'
import 'clubroom/components/header/header'
import 'clubroom/components/footer/footer'
import 'clubroom/components/newsletter_signup/newsletter_signup'
import 'clubroom/components/reservations_cta/reservations_cta'
import 'clubroom/components/event_inquiry/event_inquiry'
import 'clubroom/components/popup_notification/popup_notification'
import 'shared/components'
import 'shared/assets/javascript'
import './css'
import './javascript'
